export { PanLabelRoute } from './PanLabelRoute';
export { PanLabelSeries } from './PanLabelSeries.graphql';
